/**
 * @typedef {Object} ffInputBlockSubmitCustomProperties
 * @property {boolean} ffHasErrors => true if the input passed all validations
 *
 * @typedef {ffInputBlockSubmitCustomProperties & HTMLElement} FfInputBlockSubmit
 */

if (!customElements.get("ff-input-block-submit")) {
  class FfInputBlockSubmit extends HTMLElement {
    constructor() {
      super();

      this.ffInput = this.querySelector("[data-ff-input-block-submit]");

      const { ffErrorSelector, ffSubmitSelector } =
        this.ffInput.dataset;

      /**
       * @type {NodeListOf<HTMLElement>}
       */
      this.ffSubmitEls = document.querySelectorAll(ffSubmitSelector || "");

      /**
       * @type {HTMLElement}
       */
      this.ffErrorEl = this.dataset.hasOwnProperty("ffErrorElOutside")
          ? document.querySelector(ffErrorSelector || "")
          : this.querySelector(ffErrorSelector || "");

      /**
       * @type {HTMLElement}
       */
      this.ffErrorEmptyWrapper = this.ffErrorEl?.querySelector(".ff-error-empty-msg--js");

      /**
       * @type {HTMLElement}
       */
      this.ffErrorFormatWrapper = this.ffErrorEl?.querySelector(".ff-error-format-msg--js");

      /**
       * @type {HTMLElement}
       */
      this.ffErrorUncheckedWrapper = this.ffErrorEl?.querySelector(".ff-error-unchecked-msg--js");

      this.init();
    }

    init() {
      this.ffInput.addEventListener("input", this.inputHandler);
      this.inputHandler();
    }

    inputHandler = () => {
      const { checked, dataset, value } = this.ffInput;
      const {
        ffErrorWidthMatch,
        ffValidFormat,
      } = dataset;

      let hasError = false;

      this.ffSubmitEls.forEach((el) => {
        el.removeEventListener("click", this.submitHandlerBlock);
      });
      this.ffErrorEl.style.display = "none";

      // Hide all error wrappers
      if (this.ffErrorEmptyWrapper) this.ffErrorEmptyWrapper.style.display = "none";
      if (this.ffErrorFormatWrapper) this.ffErrorFormatWrapper.style.display = "none";
      if (this.ffErrorUncheckedWrapper) this.ffErrorUncheckedWrapper.style.display = "none";

      if (ffErrorWidthMatch) {
        this.ffErrorEl.style.width = `${this.ffInput.clientWidth}px`;
      }

      // Check for unchecked error (checkbox validation)
      if (this.ffErrorUncheckedWrapper) {
        if (!checked) {
          hasError = true;
          this.ffErrorUncheckedWrapper.style.display = "block";
        }
      }

      // Check for format error (regex validation)
      if (!hasError && this.ffErrorFormatWrapper && ffValidFormat) {
        const validation = new RegExp(ffValidFormat);
        if (!validation.test(value)) {
          hasError = true;
          this.ffErrorFormatWrapper.style.display = "block";
        }
      }

      // Check for empty error (required field validation)
      if (!hasError && this.ffErrorEmptyWrapper) {
        if (value.length == 0) {
          hasError = true;
          this.ffErrorEmptyWrapper.style.display = "block";
        }
      }

      /**
       * Update blockedBy for all submit elements
       */
      this.ffSubmitEls.forEach((submitEl) => {
        let blockedBy = JSON.parse(submitEl.dataset.blockedBy || "[]");
        if (hasError) {
          if (!blockedBy.includes(this.ffInput.name)) {
            blockedBy.push(this.ffInput.name);
          }
          submitEl.dataset.blockedBy = JSON.stringify(blockedBy);
          submitEl.addEventListener("click", this.submitHandlerBlock);
        } else {
          blockedBy = blockedBy.filter((name) => name != this.ffInput.name);
          submitEl.dataset.blockedBy = JSON.stringify(blockedBy);
        }
      });

      if (hasError) {
        this.ffValue = value;
        this.ffHasErrors = true;
        this.classList.remove("ff-input-valid");
      } else {
        this.ffValue = value;
        this.ffHasErrors = false;
        this.classList.add("ff-input-valid");
      }
    };

    submitHandlerBlock = (e) => {
      this.ffErrorEl.style.display = "";
      e.preventDefault();
    };
  }

  customElements.define("ff-input-block-submit", FfInputBlockSubmit);
}
